import tripStatuses from '../../trip-statuses';
export default function TripCheckoutTravellersController(
    $scope,
    userService,
    tripOptionsService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        vm.isDisabled = [tripStatuses.CANCELLED, tripStatuses.CONFIRMED].includes($scope.tripDetails.Status);
        $scope.list = tripOptionsService.getDropdownLists($scope.tripDetails);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/tripCheckoutTravellersController.js